import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TermsOfUseComponent } from '~shared/components/layout';
import { CaptchaGuard } from '~/captcha/guards';

const routes: Routes = [
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  { path: 'main', loadChildren: './main/main.module#MainModule' },
  { path: 'layout', loadChildren: './layout/layout.module#LayoutModule' },
  { path: 'terms-of-use', component: TermsOfUseComponent }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);




// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts